module.exports = __webpack_public_path__ + "static/media/ekskul.72eb2c1a.png";